export default "__VITE_ASSET__5Ij2l9q0__"